export default {
  title: 'Wolt-Drive-Onboarding',
  subtitle: 'Nur für Onboarding-Manager sichtbar.',
  steps: {
    request: {
      title: '1. Venue bei Wolt anfragen',
      description:
        'Kopiert die Zeile dieses Restaurants für das geteilte Wolt-Sheet. Fügen Sie sie in Spalte A der nächsten leeren Zeile ein und geben Sie Wolt im gemeinsamen Slack-Kanal Bescheid.',
    },
    activate: {
      title: '2. Prüfen und aktivieren',
      description:
        'Geben Sie die Venue-ID ein, die Wolt im Sheet eingetragen hat. Sie wird mit einer Testanfrage bei Wolt geprüft, bevor etwas gespeichert wird.',
    },
  },
  fields: {
    venue_id: {
      label: 'Wolt-Venue-ID',
      placeholder: 'z. B. 6736f9f5f9e2ab82f9150420',
      invalid: 'Eine Wolt-Venue-ID ist 24 Zeichen lang und enthält nur 0–9 und a–f.',
    },
    priority: {
      label: 'Reihenfolge der Lieferdienste',
      options: {
        wolt_primary: 'Wolt zuerst, bisherige Lieferdienste als Ausweichoption behalten',
        wolt_only: 'Nur Wolt',
      },
    },
  },
  verification: {
    verified: 'Wolt hat diese Venue bestätigt.',
    failed: 'Wolt konnte diese Venue nicht bestätigen.',
    wolt_reason: 'Antwort von Wolt: {{reason}}',
    unavailable_now: 'Wolt kann von dieser Venue gerade nicht liefern ({{reason}}). Sie können sie trotzdem speichern.',
  },
  preview: {
    label: 'Reihenfolge',
    none: 'keine',
  },
  hints: {
    internal_delivery:
      'Dieses Restaurant liefert mit eigenen Fahrern. Wolt wird genutzt, sobald der Liefermodus unten auf externe Fahrer gestellt ist.',
    invalid_stored_id:
      'Die gespeicherte Venue-ID {{venueId}} ist keine gültige Wolt-Venue-ID, daher wird Wolt für dieses Restaurant nicht genutzt. Bitte prüfen und speichern Sie die richtige.',
  },
  buttons: {
    copy_details: 'Details kopieren',
    verify: 'Prüfen',
    save: 'Speichern',
  },
  confirm: {
    title: 'Wolt Drive aktivieren?',
    description: 'Speichert die Venue-ID {{venueId}} und ändert die Reihenfolge der Lieferdienste auf: {{providers}}.',
    unsaved_providers: 'Nicht gespeicherte Änderungen an der Liste der Lieferdienste unten werden ersetzt.',
    ok: 'Speichern',
    cancel: 'Abbrechen',
  },
  toasts: {
    copied: 'Kopiert',
    copy_failed: 'Die Details konnten nicht kopiert werden. Bitte versuchen Sie es erneut.',
    saved: 'Wolt Drive ist für dieses Restaurant eingerichtet.',
    save_failed: 'Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.',
  },
};
